import { render } from "./jointChart.vue?vue&type=template&id=3823b764&scoped=true"
import script from "./jointChart.vue?vue&type=script&lang=js"
export * from "./jointChart.vue?vue&type=script&lang=js"

import "./jointChart.vue?vue&type=style&index=0&id=3823b764&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3823b764"]])

export default __exports__